import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { TextField, PasswordField } from '@marketplace/ui-elements';
import CryptoJS from 'crypto-js';
import { useAPIFetchSecret,TAPIFetchSecret } from '@marketplace/api';
import classes from './client-credentials-form.module.scss';
import { clientCredentialsValidationSchema } from './client-credentials-form.validation';
import { joiResolver } from '@hookform/resolvers/joi';

type TPersonalProfileFormFields = Omit<
  TAPIFetchSecret['data'],
  'provider.username' & 'patient.username' & 'provider.password' & 'patient.password'
>;

export const ClientCredentialsForm = () => {
  const { formatMessage } = useIntl();
  const { fetchSecret } = useAPIFetchSecret();
  
  useEffect(() => {
    fetchSecret().then(({ data: res }) => {
      reset({
        patient: res["patient"] ? decodeObject(res["patient"]) : {},
        provider: res["provider"] ? decodeObject(res["provider"]) : {},
      });
    });
  }, []);

  const {
    control,
    reset,
    formState: { errors },
  } = useForm<TPersonalProfileFormFields>({
    mode: 'onChange',
    resolver: joiResolver(clientCredentialsValidationSchema({ formatMessage })),
  });

  const decodeObject = (credentials: any): any => {
    const base64usn = CryptoJS.enc.Base64.parse(credentials.username);
    const usnUTF = CryptoJS.enc.Utf8.stringify(base64usn);
    credentials.username = usnUTF;

    const base64pwd = CryptoJS.enc.Base64.parse(credentials.password);
    const pwdUTF = CryptoJS.enc.Utf8.stringify(base64pwd);
    credentials.password = pwdUTF;
    return credentials;
  };

  return (
    <div>
      <div className={classes.fields_section}>
        <TextField
          name="patient.username"
          fieldId="patient.username"
          isRequired={false}
          disabled={true}
          error={errors?.patient_id?.message}
          control={control}
          maxLength={100}
          autoComplete="off"
          label={formatMessage({
            id: 'developer_myprofile_clientcredential_patientpofile_userid',
          })}
        />
        <PasswordField
        control={control}
        disabled={true}
        inputClassName={classes.email_input}
        error={errors?.patient_password?.message}
        type="password"
        name="patient.password"
        fieldId="patient.password"
        label={formatMessage({
          id: 'developer_myprofile_clientcredential_patientpofile_password',
        })}  
        />
      </div>
      <div className={classes.fields_section}>
        <TextField
          name="provider.username"
          fieldId="provider.username"
          disabled={true}
          control={control}
          autoComplete="off"
          error={errors?.ehr_id?.message}
          maxLength={100}
          label={formatMessage({
            id: 'developer_myprofile_clientcredential_ehrpofile_userid',
          })}
        />

      <PasswordField
        control={control}
        disabled={true}
        inputClassName={classes.email_input}
        error={errors?.provider_password?.message}
        type="password"
        name="provider.password"
        fieldId="provider.password"
        label={formatMessage({
          id: 'developer_myprofile_clientcredential_ehrpofile_password',
        })}  
        />
      </div>
    </div>
  );
};
